export default __webpack_public_path__ + "static/code_icon_mid-574733ac3e24d14dc453d876d7e3fc40.svg";